<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        small
        text
        outlined
        rounded
        @click="dialog = true"
        >{{ title }}</v-btn
      >
    </template>

    <v-card class="primary--text" v-if="dialog">
      <validation-observer ref="form" v-slot="{ invalid }">
        <v-card-title> {{ title }} </v-card-title>
        <v-card-text class="pt-0">
          <validation-provider :rules="{ required: true }" v-slot="{ errors }">
            <v-file-input
              v-model="selectedFile"
              prepend-icon="mdi-paperclip"
              label="Select File"
              single-line
              :error-messages="errors"
            ></v-file-input>
          </validation-provider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :dark="!loading"
            :disabled="loading"
            text
            @click="clear"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :dark="!loading && !invalid"
            :disabled="loading || invalid"
            text
            @click.once="upload"
            >Save</v-btn
          >
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["title"],
  data() {
    return {
      dialog: false,
      selectedFile: null,
      loading: false,
    };
  },
  methods: {
    async upload() {
      this.loading = true;
      this.$emit("uploadFile", this.selectedFile, async () => {
        this.loading = false;
        this.clear();
      });
    },
    clear() {
      this.$refs.form.reset();
      this.selectedFile = null;
      this.dialog = false;
    },
  },
};
</script>
